<!-- 导入第三方的采购单，长远、景程等 -->
<template>
    <div class="business-content-main trans-to-supplier-order-v2" v-loading="searchApParams._visible" element-loading-spinner="none">
        <div>
            <div class="bread-nav">
                <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
            </div>
            <div class="section-title" @click="showMsg">
                <div>
                    <span>订单信息</span>&nbsp;&nbsp;&nbsp;&nbsp;
                    <span v-show="!showOrderMsg && submitData.EntpCusName">供应商：{{ submitData.EntpCusName }}</span>
                </div>
                <div>
                    <el-button
                        size="small"
                        class="search-btn btn-primary"
                        @click="addCustomer(1)"
                        v-if="!dataReadonly && (type == 2 || type == 3) && permission.addSupplier"
                        >{{ permission.addSupplier }}</el-button
                    >
                    <el-button
                        size="small"
                        class="search-btn btn-primary"
                        @click="addCustomer(2)"
                        v-if="!dataReadonly && (type == 2 || type == 3) && submitData.EntpCusId && permission.editSupplier"
                        >{{ permission.editSupplier }}</el-button
                    >
                </div>
            </div>
            <div class="open-icon" @click="showMsg" v-show="!showOrderMsg">
                <img src="../../../assets/images/open-msg.png" />
            </div>
            <div class="order-infoes" v-show="showOrderMsg">
                <el-form :model="submitData" ref="formMsg" label-width="100px" style="width: 100%; padding-right: 30px; padding-left: 30px" :rules="rules">
                    <el-row :gutter="20">
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="选择供应商" prop="EntpCusId">
                                    <el-select
                                        style="width: 100%"
                                        size="small"
                                        :disabled="dataReadonly"
                                        v-model="submitData.EntpCusId"
                                        filterable
                                        clearable
                                        remote
                                        reserve-keyword
                                        :remote-method="searchCustomer"
                                        v-select-scroll-more="searchSupplierLoad"
                                        @change="customerChange($event)"
                                        @visible-change="customerVisibleChange($event)"
                                        placeholder="选择供应商"
                                    >
                                        <el-option
                                            v-for="(optionItem, index) in customerList"
                                            :key="index"
                                            :data-msg="optionItem"
                                            :label="optionItem.EntpCusName"
                                            :value="optionItem.EntpCusId"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="采购员" prop="SId">
                                    <el-select v-model="submitData.SId" :disabled="dataReadonly" filterable placeholder="请选择" style="width: 100%" size="small">
                                        <el-option v-for="(item, index) in SIdList" :key="index" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="发货方式">
                                    <el-select v-model="submitData.ShipType" :disabled="dataReadonly" placeholder="请选择" style="width: 100%" size="small">
                                        <el-option v-for="(item, index) in DeliveryMethodList" :key="index" :label="item.Text" :value="item.Value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="运输费用" prop="ShipAmount">
                                    <el-input size="small" type="number" step="0.01" :disabled="dataReadonly" min="0" v-model.trim="submitData.ShipAmount"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content bg-purple">
                                <el-form-item label="结算方式" prop="PayType">
                                    <el-select v-model="submitData.PayType" :disabled="dataReadonly" placeholder="请选择" style="width: 100%" size="small">
                                        <el-option v-for="(item, index) in payWayList" :key="index" :label="item.Text" :value="item.Value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="入仓仓库" prop="WarehouseId">
                                    <el-select
                                        size="small"
                                        style="width: 100%"
                                        v-model="submitData.WarehouseId"
                                        placeholder="请选择"
                                        filterable
                                        clearable
                                        @visible-change="warehouseVisibleChange($event)"
                                        @change="warehouseChange"
                                    >
                                        <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId">
                                            <span style="float: left">{{ item.WarehouseName }}</span>
                                            <span v-if="item.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="7">
                            <div class="grid-content bg-purple">
                                <el-form-item label="仓库地址" prop="WarehouseAddr">
                                    <el-input
                                        size="small"
                                        v-if="canNotEditAddr"
                                        :title="submitData.WarehouseAddr"
                                        v-model="submitData.WarehouseAddr"
                                        :disabled="true"
                                        style="width: 100%"
                                    ></el-input>
                                    <el-input
                                        size="small"
                                        v-else-if="dataReadonly || ((submitData.IsPartialInWarehouse || submitData.IsInStorage) && !submitData.ShipAddr)"
                                        :title="submitData.WarehouseAddr"
                                        v-model="submitData.WarehouseAddr"
                                        style="width: 100%"
                                        :disabled="true"
                                    ></el-input>
                                    <el-input size="small" v-else :title="submitData.WarehouseAddr" v-model="submitData.WarehouseAddr" style="width: 100%"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="grid-content bg-purple">
                                <el-form-item label="备注" style="width: 100%">
                                    <el-input
                                        size="small"
                                        style="width: 100%"
                                        :title="submitData.Remark"
                                        :disabled="dataReadonly"
                                        v-model.trim="submitData.Remark"
                                    ></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="4" v-if="isOrgShow">
                            <div class="grid-content bg-purple" style="width: 100%">
                                <el-form-item label="部门" prop="OrgId">
                                    <el-input v-if="dataReadonly" disabled v-model="submitData.OrgName" size="small"></el-input>
                                    <el-select
                                        size="small"
                                        style="width: 100%"
                                        v-else
                                        :disabled="dataReadonly"
                                        v-model="submitData.OrgId"
                                        filterable
                                        clearable
                                        reserve-keyword
                                        @change="orgChange($event)"
                                        @visible-change="orgVisibleChange($event)"
                                        placeholder="请选择"
                                    >
                                        <el-option
                                            v-for="optionItem in orgList"
                                            :key="optionItem.Id"
                                            :data-msg="optionItem"
                                            :label="optionItem.Name"
                                            :value="optionItem.Id"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <!--    table    -->
            <div class="section-title" @click="hideMsg()">
                <div>
                    商品明细
                    <span v-if="type == 7" style="font-size: 14px; margin-left: 10px; color: red">
                        （ 温馨提醒：已入仓的商品不能再进行修改！部分入仓的商品数量可修改，但不能少于已入仓数！ ）
                    </span>
                </div>
                <div>
                    <el-button size="small" class="search-btn btn-similar" @click="resetZeroHandle" v-if="showInitNumberBtn">清空商品数量为0</el-button>
                    <el-button
                        size="small"
                        class="search-btn btn-primary"
                        @click="showSearch()"
                        v-if="!dataReadonly && (type == 2 || type == 3 || type == 7) && permission.searchAP"
                        >搜索配件(F2)</el-button
                    >
                    <el-button size="small" class="search-btn btn-primary" @click="showIntentSearch()" v-if="!dataReadonly && type == 8 && permission.searchAP"
                        >搜索在订配件</el-button
                    >
                </div>
            </div>
        </div>
        <!-- table body -->
        <div id="infinite-list" :class="infiniteListClass" @click="hideMsg()">
            <ux-grid
                ref="infiniteTable"
                :data="dataList"
                keep-source
                :height="infiniteTableHeight"
                :checkboxConfig="{ highlight: false }"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                show-summary
                :summary-method="setSummaries"
                :row-style="setRowStyle"
                highlight-current-row
            >
                <ux-table-column class-name="table-sort" type="index" title="序号" width="65" resizable></ux-table-column>
                <ux-table-column field="APCode" title="汽配编码" edit-render show-overflow-tooltip resizable>
                    <template v-slot:header="{ column }">
                        <div class="head-view">
                            <span class="color-red">*</span>
                            {{ column.title }}
                            <span class="sort-view">
                                <i
                                    :class="['el-icon-caret-top', { active: sortActive === 'top' }]"
                                    title="升序,从小到大排序"
                                    @click="changeTableSort('top', 'APCode')"
                                ></i>
                                <i
                                    :class="['el-icon-caret-bottom', { active: sortActive === 'bottom' }]"
                                    title="降序,从大到小排序"
                                    @click="changeTableSort('bottom', 'APCode')"
                                ></i>
                            </span>
                        </div>
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['sales-apcode div-padding-12', { 'special-border': !row.APCode }]" @click="focusHandle(row.IsNew, rowIndex, 'sapcode')">
                            <i v-if="row.MainImage" title="有图片的配件信息" class="el-icon-picture" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)"></i>
                            <i v-else title="配件信息" class="el-icon-info" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)"></i>
                            <span>{{ row.APCode ? row.APCode : '请点击选中汽配编码' }}</span>
                            <el-tag v-if="row.State == 1" class="tag" type="warning">已删除</el-tag>
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="sapcode"
                            :disabled="
                                dataReadonly ||
                                    (scope.row.hasLock && lastRowIndex !== scope.rowIndex) ||
                                    (type == 4 && !scope.row.canEdit) ||
                                    (type == 7 && scope.row.WarehousedCount > 0)
                            "
                            allow-create
                            default-first-option
                            size="small"
                            v-model="scope.row.APCode"
                            value-key="APCode"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="汽配编码"
                            @change="codeChange($event, scope.rowIndex)"
                            @visible-change="apCodeVisibleChange($event)"
                            :remote-method="searchCode"
                            v-select-scroll-more="searchCodeLoad"
                            style="width: 100%"
                            popper-class="el-select-style-gray"
                            @keyup.enter.native="keyEvent($event, 'APCode', scope.row, scope.rowIndex)"
                            @keyup.right.native="keyEvent($event, 'APCode')"
                        >
                            <el-option
                                v-for="optionItem in codeList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.APCode"
                                :value="optionItem.APCode"
                            >
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name in-one-line">{{ optionItem.AutoSerise }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">{{ optionItem.GoodCode }}</div>
                                    <div class="project-iven" v-if="isInvenShow">{{ optionItem.DynaInven }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="GoodName" title="配件名称" edit-render show-overflow-tooltip resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['div-padding-12', { 'special-border': !row.GoodName }]" @click="focusHandle(row.IsNew, rowIndex, 'partsNameSelect')">
                            {{ row.GoodName }}
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            v-if="scope.row.IsNew"
                            size="small"
                            placeholder="配件名称"
                            v-model="scope.row.GoodName"
                            :disabled="
                                dataReadonly ||
                                    (scope.row.hasLock && lastRowIndex !== scope.rowIndex) ||
                                    (type == 4 && !scope.row.canEdit) ||
                                    (type == 7 && scope.row.IsInStorage)
                            "
                        />
                        <el-select
                            v-else
                            ref="partsNameSelect"
                            style="width: 100%"
                            :disabled="
                                dataReadonly ||
                                    (scope.row.hasLock && lastRowIndex !== scope.rowIndex) ||
                                    (type == 4 && !scope.row.canEdit) ||
                                    (type == 7 && scope.row.WarehousedCount > 0)
                            "
                            allow-create
                            size="small"
                            v-model="scope.row.GoodName"
                            :title="scope.row.GoodName"
                            value-key="EntpTempGoodsId"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="配件名称"
                            @change="nameChange($event, scope.rowIndex)"
                            @visible-change="apNameVisibleChange($event)"
                            @keyup.enter.native="keyEvent($event, 'GoodName')"
                            @keyup.right.native="keyEvent($event, 'GoodName')"
                            @keyup.left.native="keyEvent($event, 'GoodName')"
                            :remote-method="
                                query => {
                                    searchName(query, scope.row);
                                }
                            "
                            v-select-scroll-more="searchNameLoad"
                            popper-class="el-select-style-gray"
                        >
                            <el-option
                                v-for="optionItem in nameList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.GoodName"
                                :value="optionItem"
                            >
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name in-one-line">{{ optionItem.AutoSerise }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">{{ optionItem.GoodCode }}</div>
                                    <div class="project-iven" v-if="isInvenShow">{{ optionItem.DynaInven }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="AutoSeriseItem" title="车型" edit-render show-overflow-tooltip resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <el-tooltip effect="dark" :content="row.AutoSerise" :disabled="!row.AutoSerise" placement="top">
                            <div :class="['div-padding-12', { 'special-border': !row.AutoSerise }]" @click="focusHandle(row.IsNew, rowIndex, 'autoSeriseSelect')">
                                {{ row.AutoSerise }}
                            </div>
                        </el-tooltip>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            size="small"
                            v-model="scope.row.AutoSerise"
                            placeholder="车系"
                            v-if="scope.row.IsNew"
                            :disabled="
                                dataReadonly ||
                                    (scope.row.hasLock && lastRowIndex !== scope.rowIndex) ||
                                    (type == 4 && !scope.row.canEdit) ||
                                    (type == 7 && scope.row.WarehousedCount > 0)
                            "
                        ></el-input>
                        <el-select
                            v-else
                            ref="autoSeriseSelect"
                            :disabled="
                                dataReadonly ||
                                    (scope.row.hasLock && lastRowIndex !== scope.rowIndex) ||
                                    (type == 4 && !scope.row.canEdit) ||
                                    (type == 7 && scope.row.WarehousedCount > 0)
                            "
                            allow-create
                            size="small"
                            v-model="scope.row.AutoSeriseItem"
                            value-key="EntpTempGoodsId"
                            :title="scope.row.AutoSerise"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="车系"
                            @visible-change="autoSeriseVisibleChange($event, scope.row)"
                            @keyup.enter.native="keyEvent($event, 'AutoSerise')"
                            @keyup.right.native="keyEvent($event, 'AutoSerise')"
                            @keyup.left.native="keyEvent($event, 'AutoSerise')"
                            :remote-method="
                                query => {
                                    searchAutoSerie(query, scope.row);
                                }
                            "
                            v-select-scroll-more="searchAutoSerieLoad"
                            @change="seriseChange($event, scope.rowIndex)"
                            style="width: 100%"
                            popper-class="el-select-style-gray"
                        >
                            <el-option v-for="option in seriesList" :key="option.EntpTempGoodsId" :data-msg="option" :label="option.AutoSerise" :value="option">
                                <div class="option-content">
                                    <div class="project-Name" style="width: 300px">{{ option.AutoSerise }}</div>
                                    <div class="project-Name">{{ option.GoodName }}</div>
                                    <div class="project-Name">{{ option.APCode }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">{{ option.GoodCode }}</div>
                                    <div class="project-iven" v-if="isInvenShow">{{ option.DynaInven }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="Origin" title="产地" v-if="isOriginShow" width="160" :edit-render="{ autofocus: '.el-input__inner' }" resizable key="origin">
                    <template v-slot="{ row }">
                        <div class="div-padding-12" @click="focusHandle(row.IsNew, row, 'originRef')">{{ row.Origin }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            ref="originRef"
                            size="small"
                            v-model="scope.row.Origin"
                            @keyup.right.native="keyEvent($event, 'Origin')"
                            @keyup.left.native="keyEvent($event, 'Origin')"
                            @focus="selectAutoHandle('originRef')"
                            :disabled="dataReadonly"
                        ></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="Size" title="规格" v-if="isSizeShow" width="160" resizable key="Size">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Size }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Count" title="数量" width="100" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Count }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="purcounts-input-cell">
                            <el-input-number
                                type="number"
                                ref="countRef"
                                :min="scope.row.WarehousedCount > 0 ? scope.row.WarehousedCount : initNumber == 0 ? 0 : 1"
                                :precision="0"
                                controls-position="right"
                                size="small"
                                v-model="scope.row.Count"
                                @change="priceChange"
                                @keyup.enter.native="keyEvent($event, 'Count')"
                                @keyup.right.native="keyEvent($event, 'Count')"
                                @keyup.left.native="keyEvent($event, 'Count')"
                                @focus="selectAutoHandle('countRef')"
                                :disabled="dataReadonly || (type == 7 && scope.row.IsInStorage)"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Unit" title="单位" width="100" edit-render resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['div-padding-12', { 'special-border': !row.Unit }]" @click="focusHandle(row.IsNew, rowIndex, 'unitSelect')">{{ row.Unit }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="unitSelect"
                            :disabled="dataReadonly || (type == 4 && !scope.row.canEdit) || (type == 7 && scope.row.WarehousedCount > 0)"
                            allow-create
                            default-first-option
                            size="small"
                            v-model="scope.row.Unit"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="单位"
                            @visible-change="unitVisibleChange($event)"
                            popper-class="el-select-style-gray"
                        >
                            <el-option v-for="optionItem in unitList" :key="optionItem.Value" :label="optionItem.Value" :value="optionItem.Value"></el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="Price" title="采购价" width="100" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div :class="['div-padding-12', { 'special-border': !row.Price || row.Price === 0 }]">{{ row.Price }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="sales-input-cell">
                            <el-input-number
                                size="small"
                                style="width: 100%"
                                :min="0"
                                ref="pirceRef"
                                :precision="2"
                                :step="0.01"
                                controls-position="right"
                                v-model="scope.row.Price"
                                :disabled="dataReadonly || (type == 7 && scope.row.WarehousedCount > 0)"
                                @input="priceChange"
                                @keyup.enter.native="addItem(true)"
                                @keyup.left.native="keyEvent($event, 'Price')"
                                @focus="selectAutoHandle('pirceRef')"
                                placeholder="采购价"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="cgzj" title="采购总价" width="160" resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12 div-margin-op">
                            <img
                                src="@/assets/images/sup.png"
                                title="采购历史"
                                style="width: 27px; height: 27px"
                                v-if="row.EntpTempGoodsId"
                                @click="showHistories(row.EntpTempGoodsId)"
                            />
                            <img
                                src="@/assets/images/cus.png"
                                style="width: 26px; height: 26px; margin-right: 4px"
                                title="销售历史"
                                v-if="row.EntpTempGoodsId"
                                @click="showSaleStat(row)"
                            />
                            <img
                                src="@/assets/images/analysis.png"
                                style="width: 23px; height: 23px; margin-right: 4px"
                                title="数据分析"
                                v-if="row.EntpTempGoodsId"
                                @click="analysis(row)"
                            />
                            <span>
                                {{ row.Price * row.Count ? (row.Price * row.Count).toFixed(2) : 0 }}
                            </span>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" width="120" v-if="+type !== 6" resizable>
                    <template v-slot="{ row, rowIndex }">
                        <div class="operate" v-if="type != 1">
                            <el-button
                                size="small"
                                @click="delItem(rowIndex)"
                                icon="el-icon-delete"
                                v-if="dataList.length !== 1 && (type == 7 ? row.WarehousedCount == 0 : !dataReadonly && (type == 2 || type == 3 || type == 8))"
                            ></el-button>
                            <el-button
                                size="small"
                                type="primary"
                                @click="addItem(true)"
                                icon="el-icon-plus"
                                v-if="rowIndex + 1 === dataList.length && !dataReadonly && (type == 2 || type == 3 || type == 7 || type == 8)"
                            ></el-button>
                            <el-button
                                size="small"
                                @click="upLock(rowIndex)"
                                :icon="row.hasLock ? 'el-icon-lock' : 'el-icon-unlock'"
                                v-if="isLock && lastRowIndex !== rowIndex"
                            ></el-button>
                        </div>
                    </template>
                </ux-table-column>
            </ux-grid>
            <div class="bottom-div" @click="hideMsg">
                <div>
                    <el-button size="small" class="search-btn btn-primary" @click.stop="submitForm(type, 1)" :disabled="saving" v-if="permission.submitOrder"
                        >提交采购订单</el-button
                    >
                </div>
            </div>
        </div>
        <!--    新增供应商    -->
        <el-dialog :close-on-click-modal="false" :title="customerEditType == 2 ? '编辑供应商' : '新增供应商'" :visible.sync="dialogVisible" width="1000px">
            <div class="dialog-content" v-if="dialogVisible">
                <customerEdit ref="customerEdit" :cusId="submitData.EntpCusId" :type="customerEditType" source="2" @closeDialog="closeDialog"></customerEdit>
            </div>
        </el-dialog>

        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <!--   搜索配件    -->
        <el-dialog
            :close-on-click-modal="false"
            title="搜索配件"
            :visible.sync="searchVisible"
            width="1200px"
            v-dialog-drag
            :modal="false"
            lock-scroll
            id="search-dialog"
        >
            <div v-if="searchVisible">
                <searchAP
                    :dragType="1"
                    dragSign="transToSupplierOrder"
                    :EntpCusId="submitData.EntpCusId"
                    :EntpCusName="submitData.EntpCusName"
                    :StorageId="submitData.WarehouseId"
                    :Source="1"
                    :SelectedData="selectedData"
                    @chooseAllAPsHandle="chooseAllAPsHandle"
                    @closeDialog="closeSearchDialog"
                ></searchAP>
            </div>
        </el-dialog>
        <!--    采购历史    -->
        <el-dialog :close-on-click-modal="false" title="采购历史" :visible.sync="historyVisible" width="1200px">
            <div v-if="historyVisible">
                <APPurchaseHistory
                    :EntpTempGoodsId="EntpTempGoodsIdEdit"
                    :EntpCusId="submitData.EntpCusId"
                    :EntpCusName="submitData.EntpCusName"
                    @closeDialog="closeHistoryDialog"
                ></APPurchaseHistory>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="添加仓库地址"
            :before-close="clearAddressDialog"
            :visible.sync="addressDialogVisible"
            custom-class="base-dialog"
            width="800px"
        >
            <addAddress ref="addAddress" :submitType="1" @resetData="clearAddressDialog"></addAddress>
        </el-dialog>
        <!-- 销售历史 -->
        <el-dialog :title="SaleDialogTitle" :close-on-click-modal="false" :visible.sync="eyeHistoryVisible" append-to-body width="1200px">
            <div v-if="eyeHistoryVisible">
                <APHistory :showCusColumn="false" :EntpTempGoodsId="APId" @closeDialog="eyeHistoryVisible = false"></APHistory>
            </div>
        </el-dialog>
        <!-- 数据分析 -->
        <el-dialog :close-on-click-modal="false" title="商品销售采购数据图表" :visible.sync="goodsAnalysisVisible" width="1200px">
            <div class="dialog-content" v-if="goodsAnalysisVisible">
                <goodsAnalysis :GoodsId="APId" @closeDialog="goodsAnalysisVisible = false"></goodsAnalysis>
            </div>
        </el-dialog>
        <el-progress v-if="searchApParams._visible" class="saveProgress" type="circle" :percentage="searchApParams._percentage" />
        <!-- 新增库存 -->
        <transInventory v-if="addAPVisible" :dialogFormVisible="addAPVisible" :apParams="addAPParams" @closeDialog="closeAddAPDialog"></transInventory>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import customerEdit from '@/components/business/customerManage/customerEdit';
import searchAP from '@/components/common/searchAP';
import APMsg from '@/components/common/APMsg';
import mixin from '@/mixins/mixin';
import APPurchaseHistory from '@/components/common/APPurchaseHistory';
import addAddress from '@/components/common/addAddress';
import APHistory from '@/components/common/APHistory';
import goodsAnalysis from '@/components/common/goodsAnalysis';
import transInventory from '@/components/business/search/transInventory';
export default {
    mixins: [mixin],
    name: '',
    components: {
        customerEdit,
        searchAP,
        APMsg,
        breadcrumb,
        APPurchaseHistory,
        addAddress,
        APHistory,
        goodsAnalysis,
        transInventory
    },
    data() {
        let checkPhone = this.$util.checkPhone;
        let checkPositive = this.$util.checkPositive;
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            submitStorageName: 'transToSupplierOrder',
            dataStorageName: 'transToSupplierOrder_dataList',
            userMsg: userMsg,
            historyVisible: false,
            EntpTempGoodsIdEdit: '',
            customerEditType: 1,
            needConfirm: true,
            dialogVisible: false,
            APMsgVisible: false,
            searchVisible: false,
            priceCanBeZero: false,
            addressDialogVisible: false,
            goodsAnalysisVisible: false,

            showOrderMsg: true,
            warehouseGoodsList: [], //入库商品列表
            saving: false,
            dataReadonly: false,
            allNum: 1,
            allMoney: 0,
            editIndex: -1,
            loading: false,
            canNotEditAddr: false,
            isIntentShow: false,
            SIdList: [],
            submitData: {
                SId: userMsg.EmployeeId,
                SubmissionState: false,
                EntpCusPOId: '',
                UserId: userMsg.EmployeeId,
                ShipAmount: '',
                EntpCusId: '',
                PayType: '',
                ShipType: '',
                AddressId: null,
                PhoneNum: '',
                Remark: '',
                DetailList: [],
                Sources: 0, //采购单来源 0 是直接采购；1 是库存需求转化的采购订单；2 销售单转化采购订单；3 询价转化的采购订单
                Bank: '',
                AccountName: '',
                Account: '',
                AddressName: '',
                WarehouseId: '',
                WarehouseAddr: '',
                OrgId: '',
                OrgName: ''
            },
            Limit: 10,
            download_url: this.$util.QN_URL_BASE,
            customerList: [],
            DeliveryMethodList: [], // 发货方式列表
            payWayList: [],
            addressList: [],
            codeList: [],
            nameList: [],
            seriesList: [],
            dataList: [],
            unitList: [],
            type: 3,
            id: '',
            pageTitle: '',
            rules: {
                EntpCusId: [
                    {
                        required: true,
                        message: '填选择供应商',
                        trigger: 'change'
                    }
                ],
                SId: [
                    {
                        required: true,
                        message: '填选择采购员',
                        trigger: 'change'
                    }
                ],
                PhoneNum: [
                    {
                        required: true,
                        validator: checkPhone,
                        trigger: 'blur'
                    },
                    {
                        required: true,
                        message: '请填写手机号',
                        trigger: 'blur'
                    }
                ],
                AddressId: [
                    {
                        required: true,
                        message: '填写收货地址',
                        trigger: 'blur'
                    }
                ],
                ShipAmount: [
                    {
                        validator: checkPositive,
                        trigger: 'blur'
                    }
                ],
                PayType: [
                    {
                        required: true,
                        message: '填写结算方式',
                        trigger: 'blur'
                    }
                ],
                WarehouseId: [
                    {
                        required: true,
                        message: '请选择仓库',
                        trigger: 'blur'
                    }
                ],
                WarehouseAddr: [{ required: true, message: '请填写仓库地址', trigger: 'blur' }],
                OrgId: [{ required: true, message: '请选择部门', trigger: 'blur' }]
            },
            permission: {},
            permission3: {},
            warehouseList: [], //仓库地址
            eyeHistoryVisible: false,
            SaleDialogTitle: '',
            changeCodeConfig: false,
            canInStorages: false, //通过计算已入仓数和标签数得出

            infiniteListHeight: 0, // 列表高度，在收起信息栏时进行实时计算
            selectedData: [],
            apcodeSource: null, // 用于处理取消编码请求操作
            // 是否预先加载汽配编码列表数据
            isPreloadApCodeList: false,
            // 用于供应商列表，分页搜索功能
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于汽配编码列表，分页搜索功能
            codeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于配件名称列表，分页搜索功能
            nameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于车型列表，分页搜索功能
            autoSerieForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 加锁：选择商品完成回车或点加号后触发锁定不可修改
            hasLock: false,
            // 汽配编码排序标识
            sortActive: '',
            // 搜索配件弹框返回参数
            searchApParams: {
                _visible: false,
                _percentage: 0,
                _limit: 500,
                // 总数量
                _totalCount: 0
            },
            // 功能配置项：初始数量值 - 改功能暂时注释 2021-7-23
            initNumber: 1,
            isAddWaitIn: true,
            // 新增库存
            addAPVisible: false,
            addAPParams: {},
            isInvenShow: false,
            isOrgShow: false, //开单部门
            orgList: [],
            isOriginShow: false, //产地
            isSizeShow: false //规格
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        this.getSendWay();
        this.getPay();
        this.getSIdList();
    },
    mounted() {
        this.permission = this.$util.getPermission('supplierBuyOrder');
        this.permission3 = this.$util.getPermission('purchasesOrderTakeIn');

        let purOrderModel = this.$util.getLocalStorage('cyPurOrderData');
        let datalist = purOrderModel.GoodsList;
        if (purOrderModel.Source == 'JC') this.pageTitle = '导入景城采购单';

        if (purOrderModel) {
            this.submitData = purOrderModel;
            this.customerList.push({
                EntpCusId: purOrderModel.EntpCusId,
                EntpCusName: purOrderModel.EntpCusName,
                FullAddress: purOrderModel.FullAddress
            });
            let i = this.SIdList.findIndex(item => {
                if (item.EmployeeId == purOrderModel.SId) {
                    return true;
                }
            });
            if (i == -1) {
                this.SIdList.push({
                    EmployeeId: purOrderModel.SId,
                    EmployeeName: purOrderModel.SName
                });
            }
        }
        if (purOrderModel && purOrderModel.WarehouseId) {
            this.warehouseList.push({
                WarehouseId: purOrderModel.WarehouseId,
                WarehouseName: purOrderModel.WarehouseName,
                Type: purOrderModel.WarehouseType
            });
        } else {
            this.getdefaultWarehouses();
        }

        if (datalist && datalist.length > 0) {
            let _allNum = 0;
            let _allMoney = 0;
            for (let i = 0; i < datalist.length; i++) {
                _allNum += Number(datalist[i].Count);
                _allMoney += datalist[i].Count * datalist[i].Price ? datalist[i].Count * datalist[i].Price : 0;
                datalist[i].hasLock = this.hasLock;
                this.$set(datalist[i], 'GoodNameItem', datalist[i].GoodName);
                this.$set(datalist[i], 'AutoSeriseItem', datalist[i].AutoSerise);
            }
            this.allMoney = _allMoney;
            this.allNum = _allNum;
            this.dataList = datalist;
        }

        //当表格出现滚动条后，编辑最后一条数据时，点击滚动条内底部的空白处单元格的编辑状态没有去除
        //为了解决这个bug在表格的父级监听点击事件来清除单元格激活状态
        let tablebody = document.querySelector('.elx-table--body-wrapper');
        tablebody.addEventListener('click', this.clearActived, false);
        window.onresize = () => {
            this.resetHeight();
        };
        setTimeout(() => {
            this.resetHeight();
        }, 0);
    },
    computed: {
        // 当type为6时定义新样式
        infiniteListClass() {
            return +this.type === 6 ? 'infinite-list-special-class' : '';
        },
        // 列表高度
        infiniteTableHeight() {
            let bottomHeight = this.type == 5 ? 24 : 78;
            let resultHeight = this.infiniteListHeight - bottomHeight;
            return +this.type === 6 ? 'auto' : resultHeight;
        },
        // 是否加锁
        isLock() {
            return this.hasLock && [2, 3, 7, 8].includes(this.type * 1);
        },
        // 列表数据最后一行下标
        lastRowIndex() {
            return Array.isArray(this.dataList) ? this.dataList.length - 1 : 0;
        },
        // 是否展示：清空商品数量为0按钮
        showInitNumberBtn() {
            return this.initNumber == 0 && ![1, 4, 5, 6].includes(this.type * 1);
        }
    },
    methods: {
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            if (key === 107 || key === 187) {
                if (!this.searchVisible) this.addItem(false);
            }
            if (key == 113) {
                if (!this.dataReadonly && (this.type == 2 || this.type == 3 || this.type == 7) && this.permission.searchAP) this.searchVisible = true;
            }
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['xsspjgwl', 'kdyjz', 'spmrsl', 'lybsdr', 'syztsj', 'kdbjsd', 'ddhhm', 'ddkcs', 'xskdxskdbm', 'kdspcd', 'kdspgg'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            let rValue = data[i].RValue;
                            switch (code) {
                                case 'xsspjgwl': //获取采购价可为零配置
                                    this.priceCanBeZero = result;
                                    break;
                                case 'kdyjz': // 获取预加载商品数据的功能设置结果
                                    this.isPreloadApCodeList = result;
                                    break;
                                case 'spmrsl': // 功能配置：获取客户配置的初始数量值
                                    if (result && !isNaN(rValue)) {
                                        this.initNumber = rValue;
                                        if (this.dataList && this.dataList.length > 0) {
                                            let lastData = this.dataList[this.dataList.length - 1];
                                            if (!lastData.EntpTempGoodsId) {
                                                lastData.Count = this.initNumber;
                                            }
                                        }
                                    }
                                    break;
                                case 'lybsdr': // 获取留余的计算方式
                                    this.isAddWaitIn = !result;
                                    break;
                                case 'syztsj': // 获取在订展示配置
                                    this.isIntentShow = result;
                                    break;
                                case 'kdbjsd': // 获取权限：选择商品完成回车或点加号后触发锁定不可修改
                                    this.hasLock = !result;
                                    break;
                                case 'ddhhm': // 是否展示互换码
                                    this.changeCodeConfig = result;
                                    break;
                                case 'ddkcs':
                                    this.isInvenShow = result;
                                    break;
                                case 'xskdxskdbm': //开单部门
                                    this.isOrgShow = result;
                                    break;
                                case 'kdspcd': //是否出现产地
                                    this.isOriginShow = result;
                                    break;
                                case 'kdspgg': //是否出现规格
                                    this.isSizeShow = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        // 关闭新增库存弹框
        async closeAddAPDialog(result, row) {
            this.addAPVisible = false;
            if (!row) return;
            this.$set(this.dataList, this.addAPParams.index, {
                ...row,
                Count: this.initNumber,
                // 是否可编辑，用于报价转销售情况时新增数据情况
                canEdit: this.type == 4,
                State: 0,
                StorageInventory: 0,
                OrderWaitOutQuantity: 0,
                POrderWaitInQuantity: 0,
                Price: row.CostPrice // 成本价赋值给采购价
            });
        },
        // 清空数量为零的Row
        resetZeroHandle() {
            this.dataList = this.dataList.filter(f => f.Count * 1 > 0);
            this.$util.successMsg('已清空商品数量为 0 的商品');
        },
        // 编码排序
        changeTableSort(type, prop) {
            let sortArr = [];
            let listArr = this.dataList.filter(f => f[prop]);
            let otherArr = this.dataList.filter(f => !f[prop]);
            if (type === 'top') {
                this.sortActive = 'top';
                sortArr = listArr.sort((a, b) => a[prop].localeCompare(b[prop]));
            } else {
                this.sortActive = 'bottom';
                sortArr = listArr.sort((a, b) => b[prop].localeCompare(a[prop]));
            }
            this.dataList = [...sortArr, ...otherArr];
        },
        // 计算infinite-list高度
        resetHeight() {
            let listObj = document.getElementById('infinite-list');
            if (!listObj) return;
            let clientObj = listObj.getBoundingClientRect();
            this.infiniteListHeight = window.innerHeight - clientObj.top;
        },
        getSIdList() {
            this.$util.getCommonSIdList().then(data => {
                this.SIdList = data;
            });
        },
        getConfigData() {
            this.$util.searchGoodsUnit().then(res => {
                this.unitList = res;
            });
        },
        // 搜索
        showSearch() {
            if (this.dataList.length > 0) {
                this.selectedData = [];
                this.dataList.forEach(item => {
                    if (item.EntpTempGoodsId) this.selectedData.push(item.EntpTempGoodsId);
                });
            }
            this.searchVisible = true;
        },
        // 搜索配件弹框 - 确认筛选结果按钮操作
        chooseAllAPsHandle(data) {
            data.searchData.CheckSalesOutWHCout = false;
            this.searchVisible = false;
            this.searchApParams = {
                ...data.searchData,
                limit: this.searchApParams._limit,
                _visible: true,
                _percentage: 0,
                _limit: this.searchApParams._limit,
                _totalCount: data.searchData.limit
            };
            this.loopSearch();
        },
        // 开始循环
        async loopSearch() {
            const { data } = await this.$util.axiosPost({
                url: '/api/EntpGoods/GetFullDataGoodsListForOrder',
                data: this.searchApParams,
                hideLoading: true
            });
            this.searchApParams._percentage = parseInt(((this.searchApParams.page * this.searchApParams.limit) / this.searchApParams._totalCount) * 100);
            this.searchApParams.page += 1;
            let _stop = !data || data.length < this.searchApParams._limit;
            this.closeSearchDialog(data);
            if (_stop) {
                this.searchApParams._percentage = 100;
                this.searchApParams._visible = false;
            } else {
                this.loopSearch();
            }
        },
        closeSearchDialog(items, noClose = false) {
            let that = this;
            let itemList = [...items];
            if (itemList.length == 0) {
                if (!noClose) {
                    that.searchVisible = false;
                    return;
                }
            }
            let newGoodsList = [];
            for (let i = 0; i < itemList.length; i++) {
                let item = itemList[i];
                let isExist = false;
                that.dataList.forEach((e, index) => {
                    if (item.APCode == e.APCode) {
                        isExist = true;
                        e.StorageInventory = item.StorageInventory;
                    }
                });
                if (!isExist) {
                    let newGoods = {
                        EntpTempGoodsId: item.EntpTempGoodsId,
                        APCode: item.APCode,
                        GoodName: item.GoodName,
                        GoodNameItem: item.GoodName,
                        AutoSerise: item.AutoSerise,
                        AutoSeriseItem: item.AutoSerise,
                        Count: this.initNumber,
                        // Price: item.CostPrice ? item.CostPrice : "",
                        Price: item.LatestPurPrice ? item.LatestPurPrice : item.CostPrice,
                        Unit: item.Unit,
                        Remark: item.Remark,
                        CodeRepeat: false,
                        WarehousedCount: 0,
                        Inventory: item.Inventory,
                        StorageInventory: item.StorageInventory,
                        OrderWaitOutQuantity: item.OrderWaitOutQuantity,
                        POrderWaitInQuantity: item.POrderWaitInQuantity,
                        State: 0,
                        // 是否可编辑，用于报价转销售情况时新增数据情况
                        canEdit: this.type == 4,
                        IntenCount: item.IntenCount,
                        MainImage: item.MainImage,
                        Origin: item.Origin,
                        Size: item.Size
                    };
                    if (!isNaN(item._count)) {
                        newGoods.Count = item._count;
                    }
                    if (!isNaN(item._price)) {
                        newGoods.Price = item._price;
                    }
                    newGoodsList.push(newGoods);
                }
                // 重复数据并且从搜索配件双击回来时修改数量和销售价
                if (noClose && isExist) {
                    let fIdx = that.dataList.findIndex(f => f.APCode === item.APCode);
                    if (fIdx > -1) {
                        that.dataList[fIdx].Count = item._count;
                        that.dataList[fIdx].Price = item._price;
                    }
                }
            }
            //判断最后一条数据是否空值，是的话移到最后
            if (that.dataList.length == 0) {
                that.dataList = that.dataList.concat(newGoodsList);
            } else {
                let lastItem = that.dataList[that.dataList.length - 1];
                if (!lastItem.APCode && !lastItem.GoodName) {
                    that.dataList.splice(that.dataList.length - 1, 1);
                    that.dataList = that.dataList.concat(newGoodsList);
                    that.dataList.push(lastItem);
                } else {
                    that.dataList = that.dataList.concat(newGoodsList);
                }
            }

            that.priceChange();
            if (!noClose) {
                that.searchVisible = false;
            }
            that.$nextTick(() => {
                if (that.$refs['count' + (that.dataList.length - 1).toString()]) {
                    that.$refs['count' + (that.dataList.length - 1).toString()][0].focus();
                }
            });
        },
        // 配件信息
        hideMsg() {
            this.showOrderMsg = false;
            setTimeout(() => {
                this.resetHeight();
            }, 100);
        },
        showMsg() {
            this.showOrderMsg = true;
            setTimeout(() => {
                this.resetHeight();
            }, 100);
        },
        // 配件信息
        showAPMsgDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
        },

        // 数量或者价格变动
        priceChange() {
            let DetailList = this.dataList;
            let _allNum = 0;
            let _allMoney = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allNum += Number(DetailList[i].Count);
                _allMoney += Number(DetailList[i].Count * DetailList[i].Price ? (DetailList[i].Count * DetailList[i].Price).toFixed(3) : 0);
            }
            this.allMoney = _allMoney;
            this.allNum = _allNum;
            // this.dataList = DetailList;
        },
        closeDialog(edit) {
            this.dialogVisible = false;
            if (edit) {
                this.searchCustomer();
            }
        },
        addCustomer(type) {
            this.customerEditType = type;
            this.dialogVisible = true;
        },
        // 提交采购单
        submitForm(type, SubmissionState) {
            this.$refs['formMsg'].validate(valid => {
                if (valid) {
                    let _dataList = this.dataList;
                    if (!this.submitData.EntpCusId && this.type != 4) {
                        this.$util.warningMsg('请选择供应商');
                        this.showMsg();
                        return;
                    }
                    for (let i = 0; i < _dataList.length; i++) {
                        if (!_dataList[i].APCode) {
                            this.$util.warningMsg('请填写配件编码');
                            return;
                        }
                        if (!_dataList[i].GoodName) {
                            this.$util.warningMsg('请填写配件名称');
                            return;
                        }
                        if (_dataList[i].State != 0) {
                            this.$util.warningMsg('商品【' + _dataList[i].GoodName + '（' + _dataList[i].APCode + '）' + '】已删除');
                            return;
                        }
                        if (!_dataList[i].Count || Number(_dataList[i].Count) < 0) {
                            this.$util.warningMsg('请填写正确的配件数量');
                            return;
                        } else {
                            if (!_dataList[i].IsInStorage && _dataList[i].WarehousedCount > 0 && _dataList[i].Count < _dataList[i].WarehousedCount) {
                                this.$util.warningMsg('商品数量不能少于已入仓数，已入仓' + _dataList[i].WarehousedCount + '个商品');
                                return;
                            }
                        }
                        if (!_dataList[i].AutoSerise) {
                            this.$util.warningMsg('请填写车型');
                            return;
                        }
                        if (!_dataList[i].Unit) {
                            this.$util.warningMsg('请填写单位');
                            return;
                        }
                        // 只有提交的时候才提示
                        if (!this.priceCanBeZero && this.SubmissionState === '1') {
                            if (!_dataList[i].Price || _dataList[i].Price <= 0) {
                                this.$util.warningMsg('请填写正确的采购价');
                                return;
                            }
                        }
                        // let sameItems = _dataList.filter(item=>item.APCode == _dataList[i].APCode);
                        // if(sameItems.length>1){
                        //   this.$util.warningMsg(`选择了相同的配件【${_dataList[i].GoodName}】，编码为【${_dataList[i].APCode}】`);
                        //   return;
                        // }
                    }
                    this.submitData.GoodsList = _dataList;
                    if (this.saving) {
                        return;
                    }
                    let checkRepeat = this.checkRepeatAndReturnData();
                    if (checkRepeat.hasRepeat) {
                        this.$confirm('订单含有重复商品项，是否需要累加', '', {
                            type: 'error',
                            distinguishCancelAndClose: true
                        })
                            .then(() => {
                                // 覆盖数据
                                this.dataList = checkRepeat.row;
                                this.submitData.GoodsList = checkRepeat.row;
                                this.submitFormAgain(type, SubmissionState);
                                // //只有新增的时候才做提示
                                // if (this.submitData.EntpCusPOId) this.submitFormAgain(type, SubmissionState);
                                // else {
                                //     this.saving = true;
                                //     this.isExistUnsubmittedPOrder()
                                //         .then(resp => {
                                //             if (resp.data.IsExist) {
                                //                 this.$confirm(resp.errmsg, '提示', {
                                //                     closeOnClickModal: false,
                                //                     closeOnPressEscape: false,
                                //                     distinguishCancelAndClose: true,
                                //                     dangerouslyUseHTMLString: true,
                                //                     customClass: 'mbox_ext'
                                //                 })
                                //                     .then(() => {
                                //                         this.submitData.KeepEntpCusPOId = resp.data.KeepEntpCusPOId;
                                //                         this.submitData.CEntpCusPOId = resp.data.CEntpCusPOId;
                                //                         this.submitFormAgain(type, SubmissionState);
                                //                     })
                                //                     .catch(() => {
                                //                         this.submitData.KeepEntpCusPOId = '';
                                //                         this.submitData.CEntpCusPOId = '';
                                //                         this.submitFormAgain(type, SubmissionState);
                                //                     });
                                //             } else this.submitFormAgain(type, SubmissionState);
                                //         })
                                //         .catch(() => {
                                //             this.saving = false;
                                //         });
                                // }
                            })
                            .catch(() => {});
                    } else {
                        this.submitFormAgain(type, SubmissionState);
                        //只有新增的时候才做提示
                        // if (this.submitData.EntpCusPOId) this.submitFormAgain(type, SubmissionState);
                        // else {
                        //     this.saving = true;
                        //     this.isExistUnsubmittedPOrder()
                        //         .then(resp => {
                        //             if (resp.data.IsExist) {
                        //                 this.$confirm(resp.errmsg, '提示', {
                        //                     closeOnClickModal: false,
                        //                     closeOnPressEscape: false,
                        //                     distinguishCancelAndClose: true,
                        //                     dangerouslyUseHTMLString: true,
                        //                     customClass: 'mbox_ext'
                        //                 })
                        //                     .then(() => {
                        //                         this.submitData.KeepEntpCusPOId = resp.data.KeepEntpCusPOId;
                        //                         this.submitData.CEntpCusPOId = resp.data.CEntpCusPOId;
                        //                         this.submitFormAgain(type, SubmissionState);
                        //                     })
                        //                     .catch(() => {
                        //                         this.submitData.KeepEntpCusPOId = '';
                        //                         this.submitData.CEntpCusPOId = '';
                        //                         this.submitFormAgain(type, SubmissionState);
                        //                     });
                        //             } else this.submitFormAgain(type, SubmissionState);
                        //         })
                        //         .catch(() => {
                        //             this.saving = false;
                        //         });
                        // }
                    }
                } else {
                    this.$util.warningMsg('有必填项未填写');
                    this.showMsg();
                }
            });
        },
        //检查供应商是否有未提交的订单
        isExistUnsubmittedPOrder() {
            return new Promise(resolve => {
                this.$util
                    .axiosGet({
                        url: '/api/EntpPurchaseOrder/IsExistUnsubmittedPOrderBySId',
                        data: {
                            EntpCusId: this.submitData.EntpCusId,
                            EntpCusPOId: this.submitData.EntpCusPOId
                        }
                    })
                    .then(res => {
                        resolve(res);
                    });
            });
        },
        submitFormAgain(type, SubmissionState) {
            let that = this;
            this.saving = true;
            let url = '/api/EntpPurchaseOrder/SaveCYOrder';

            this.$util
                .axiosPost({
                    url: url,
                    data: this.submitData
                })
                .then(() => {
                    this.$store.commit('updateNeedRefresh', true);
                    this.needConfirm = false;
                    this.$util.successMsg('提交采购订单成功');

                    this.removePageChace();

                    //添加默认入仓仓库
                    if (that.submitData.WarehouseId) {
                        var wd= {
                                WarehouseId: that.submitData.WarehouseId,
                                WarehouseName: that.submitData.WarehouseName,
                                Address: that.submitData.WarehouseAddr,
                                WarehouseType: that.warehouseType
                                };
                        let CacheList=[];        
                        CacheList.push({CacheKey:'defaultInWarehouses',CacheValue:JSON.stringify(wd)});
                        that.$util.SetEntpCache(CacheList);                        
                    }                    

                    setTimeout(() => {
                        this.$router.push('/purchaseManage/purchaseOrders');
                    }, 2000);
                })
                .catch(() => {
                    this.saving = false;
                });
        },
        // 检查是否有重复项及返回已合并数量的数据
        checkRepeatAndReturnData() {
            let [list, row, hasRepeat] = [this.submitData.GoodsList, [], false];
            list.forEach(item => {
                let index = row.findIndex(f => f.APCode === item.APCode);
                if (index > -1) {
                    hasRepeat = true;
                    if(item.Count){
                        row[index].Count = Number(row[index].Count)+ Number(item.Count);
                    }
                        
                } else {
                    row.push(Object.assign({}, item));
                }
            });
            return {
                hasRepeat,
                row
            };
        },
        // 删除某行
        delItem(index) {
            if (this.dataList.length != 1) {
                this.dataList.splice(index, 1);
            }
            this.priceChange();
        },
        // 添加一行
        addItem(addPageChace) {
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    this.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    this.$util.warningMsg('请填写配件名称');
                    return;
                }
                if (!_dataList[i].Count || Number(_dataList[i].Count) < 0) {
                    this.$util.warningMsg('请填写正确的配件数量');
                    return;
                }
                if (!_dataList[i].AutoSerise) {
                    this.$util.warningMsg('请填写车型');
                    return;
                }
                if (!_dataList[i].Unit) {
                    this.$util.warningMsg('请填写单位');
                    return;
                }
                if (!this.priceCanBeZero) {
                    if (!_dataList[i].Price || _dataList[i].Price < 0) {
                        this.$util.warningMsg('请填写正确的采购价');
                        return;
                    }
                }
            }
            if (addPageChace) {
                this.addPageChace(); //添加采购订单缓存
            }

            // 上锁
            if (this.isLock) {
                this.dataList.forEach(ele => {
                    ele.hasLock = true;
                });
            }

            this.dataList.push({
                EntpTempGoodsId: '',
                APCode: '',
                GoodName: '',
                GoodNameItem: '',
                AutoSerise: '',
                AutoSeriseItem: '',
                Count: this.initNumber,
                Price: '',
                Unit: '',
                Remark: '',
                CodeRepeat: false,
                WarehousedCount: 0,
                Inventory: 0, //商品总数量
                StorageInventory: 0, //仓库库存数量
                OrderWaitOutQuantity: 0,
                POrderWaitInQuantity: 0,
                State: 0,
                // 是否可编辑，用于报价转销售情况时新增数据情况
                canEdit: this.type == 4,
                MainImage: '',
                Size: '',
                Origin: ''
            });

            setTimeout(() => {
                this.$refs.infiniteTable.scrollToRow(this.dataList[this.dataList.length - 1]);
                this.$refs.infiniteTable.setActiveRow(this.dataList[this.dataList.length - 1]);
                if (this.dataList.length > 1) {
                    let ilEle = document.getElementsByClassName('business-content')[0];
                    ilEle.scrollTop = ilEle.scrollHeight;
                }
            }, 100);

            this.priceChange();

            let that = this;
            that.$nextTick(() => {
                setTimeout(function() {
                    that.$refs.sapcode.focus();
                }, 200);
            });
        },
        // 解锁
        upLock(index) {
            this.$set(
                this.dataList,
                index,
                Object.assign({}, this.dataList[index], {
                    hasLock: !this.dataList[index].hasLock
                })
            );
        },
        // 点击展开下拉框
        focusHandle(isNew, index, type) {
            if (type === 'sapcode' && !isNew) {
                setTimeout(() => {
                    this.$refs[`sapcode`].focus();
                }, 200);
            }
            if (type === 'partsNameSelect' && !isNew) {
                setTimeout(() => {
                    this.$refs[`partsNameSelect`].focus();
                }, 200);
            }
            if (type === 'autoSeriseSelect' && !isNew) {
                setTimeout(() => {
                    this.$refs[`autoSeriseSelect`].focus();
                }, 200);
            }
            if (type === 'unitSelect') {
                setTimeout(() => {
                    this.$refs[`unitSelect`].focus();
                }, 200);
            }
        },
        // 自动选中输入框内容
        selectAutoHandle(ref) {
            this.$refs[ref].select();
        },
        //判断是否有缓存,加载缓存或者请求订单信息
        loadStorage() {
            let transOrderModel = this.$util.getLocalStorage(this.submitStorageName);
            let datalist = this.$util.getLocalStorage(this.dataStorageName);
            if (transOrderModel && datalist && datalist.length > 0) {
                return {
                    model: transOrderModel,
                    list: datalist
                };
            } else {
                return null;
            }
        },
        //添加页面缓存
        addPageChace() {
            this.removePageChace();
            this.$util.setLocalStorage(this.submitStorageName, this.submitData);
            this.$util.setLocalStorage(this.dataStorageName, this.dataList);
        },
        //清除页面缓存
        removePageChace() {
            this.$util.clearLocalStorage(this.submitStorageName);
            this.$util.clearLocalStorage(this.dataStorageName);
        },
        //从缓存中读取数据
        getDataFromChace(data) {
            let transOrderModel = data.model;
            let datalist = data.list;

            if (transOrderModel) {
                this.searchCustomer();
                // this.getAddressList();
                this.submitData = transOrderModel;
            }
            if (transOrderModel && transOrderModel.WarehouseId) {
                this.warehouseList.push({
                    WarehouseId: transOrderModel.WarehouseId,
                    WarehouseName: transOrderModel.WarehouseName,
                    Type: transOrderModel.WarehouseType
                });
            } else {
                this.getdefaultWarehouses();
            }
            if (datalist && datalist.length > 0) {
                let _allNum = 0;
                let _allMoney = 0;
                for (let i = 0; i < datalist.length; i++) {
                    _allNum += Number(datalist[i].Count);
                    _allMoney += datalist[i].Count * datalist[i].Price ? datalist[i].Count * datalist[i].Price : 0;
                    datalist[i].hasLock = this.hasLock;
                }
                this.allMoney = _allMoney;
                this.allNum = _allNum;
                this.dataList = datalist;
            }
        },

        //从缓存中获取默认出仓仓库
        getdefaultWarehouses() {
            if (this.dataReadonly) return;
            return new Promise(resolve => {
                this.$util.GetEntpCache({CacheKey:'defaultInWarehouses'},true).then(result => {
                    if (result) {
                        let data =JSON.parse(result)
                        let isexit = this.warehouseList.find(e => e.WarehouseId == data.WarehouseId);
                        if (!isexit) {
                            this.warehouseList.push({
                                WarehouseId: data.WarehouseId,
                                WarehouseName: data.WarehouseName,
                                Type: data.WarehouseType,
                                Address:data.Address
                            });
                        }

                        this.$set(this.submitData, 'WarehouseId', data.WarehouseId);
                        this.$set(this.submitData, 'WarehouseName', data.WarehouseName);
                        this.$set(this.submitData, 'WarehouseAddr', data.Address);

                        this.warehouseType = data.WarehouseType;
                    }
                    resolve();
                });
            });
        }, 
        /**
         * 从缓存中获取默认数据
         * ShipType 发货方式
         * PayType 结算方式
         * WarehouseAddr 收货地址
         * WarehouseId 仓库ID
         * WarehouseName 仓库名称
         */
        getDefaultData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpCustomers/GetCustOrderNewsData',
                    data: {
                        cid: this.submitData.EntpCusId,
                        type: '1'
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        this.submitData.ShipType = data.ShipType;
                        this.submitData.PayType = data.PayType;
                    }
                });
        },
        // 搜索供应商，分页
        searchCustomer(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.customerList = [];
            }
            if (this.supplierForm.stopLoad) return;
            this.loading = true;
            this.$util.searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit).then(data => {
                this.loading = false;
                if (!data) return;
                this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                this.customerList = this.$util.uniqueArr(this.customerList, data);
                //修改客户时要更新页面上展现的名称
                if (this.customerList.length > 0) {
                    let currCust = this.customerList.find(e => e.EntpCusId == this.submitData.EntpCusId);
                    if (currCust) {
                        this.submitData.EntpCusName = currCust.EntpCusName;
                    }
                }
            });
        },
        // 供应商列表，加载更多
        searchSupplierLoad() {
            this.supplierForm.Page += 1;
            this.searchCustomer();
        },
        // 改变商品数量
        handleNumChange(data, value, index) {
            this.dataList[index].Count = value;
        },
        // 获取地址
        getAddressList() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetAddressList',
                    data: {
                        Page: 1,
                        Limit: 999,
                        EntpId: this.userMsg.EntpId
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) {
                        this.addressList = [];
                        return;
                    }
                    let _addressList = [];
                    for (let i = 0; i < data.length; i++) {
                        _addressList.push({
                            Text: `${data[i].Province}${data[i].City}${data[i].District}${data[i].Addr}`,
                            Value: data[i].Id
                        });
                    }
                    this.addressList = _addressList;
                });
        },
        // 搜索汽配编码
        async searchCode(key) {
            // 取消请求
            if (this.apcodeSource) {
                this.apcodeSource.cancel();
            }
            // 初始化对象
            this.apcodeSource = this.axios.CancelToken.source();
            if (![undefined].includes(key)) {
                this.codeForm.Page = 1;
                this.codeForm.stopLoad = false;
                this.codeForm.key = key;
                this.codeList = [];
            }
            if (this.codeForm.stopLoad) return;
            this.loading = true;
            const { data } = await this.$util.axiosGet({
                url: '/api/EntpGoods/GetGoodsSelItemsForPurchaseOrder',
                data: {
                    APCode: this.codeForm.key,
                    Page: this.codeForm.Page,
                    Limit: this.codeForm.Limit
                },
                hideLoading: true,
                cancelToken: this.apcodeSource.token // 取消操作标识
            });
            this.loading = false;
            if (!data) return;
            this.codeForm.stopLoad = data.length < this.codeForm.Limit;
            this.codeList = this.$util.uniqueArr(this.codeList, data);
        },
        // 汽配编码列表，加载更多
        searchCodeLoad() {
            if (!this.loading) {
                this.codeForm.Page += 1;
                this.searchCode();
            }
        },
        // 搜索名称
        searchName(key, item) {
            if (![undefined].includes(key)) {
                this.nameForm.Page = 1;
                this.nameForm.stopLoad = false;
                this.nameForm.key = key;
                this.nameList = [];
            }
            if (this.nameForm.stopLoad) return;
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForPurchaseOrder',
                    data: {
                        GoodName: this.nameForm.key,
                        Page: this.nameForm.Page,
                        Limit: this.nameForm.Limit
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    if (!res.data) return;
                    this.nameForm.stopLoad = res.data.length < this.nameForm.Limit;
                    this.nameList = this.$util.uniqueArr(this.nameList, res.data);
                    if (item) {
                        item.VGoodName = key;
                        item.GoodName = key;
                        this.seriesList = res.data;
                    }
                });
        },
        // 汽配名称列表，加载更多
        searchNameLoad() {
            this.nameForm.Page += 1;
            this.searchName();
        },
        // 搜车系
        searchAutoSerie(key, item) {
            if (![undefined].includes(key)) {
                this.autoSerieForm.Page = 1;
                this.autoSerieForm.stopLoad = false;
                this.autoSerieForm.key = key;
                this.seriesList = [];
            }
            if (this.autoSerieForm.stopLoad) return;
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForPurchaseOrder',
                    data: {
                        GoodName: item ? item.VGoodName : '', //配合商品名称查
                        Page: this.autoSerieForm.Page,
                        Limit: this.autoSerieForm.Limit,
                        OnlySeries: true,
                        SeriesName: this.autoSerieForm.key
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    if (!res.data) return;
                    this.autoSerieForm.stopLoad = res.data.length < this.autoSerieForm.Limit;
                    this.seriesList = this.$util.uniqueArr(this.seriesList, res.data);
                });
        },
        // 车系列表，加载更多
        searchAutoSerieLoad() {
            this.autoSerieForm.Page += 1;
            this.searchAutoSerie();
        },
        //  结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        // 获取发货方式
        getSendWay() {
            this.$util.getSendWay().then(data => {
                this.DeliveryMethodList = data;
            });
        },
        // 获取仓库列表
        getWarehouse() {
            this.$util.getWarehouse(1).then(data => {
                this.warehouseList = data;
            });
        },
        // 名称改变
        nameChange(item, index) {
            if (!item) {
                this.dataList[index].VGoodName = '';
                this.dataList[index].GoodName = '';
            } else if (typeof item == 'string') {
                this.dataList[index].VGoodName = item;
                this.dataList[index].GoodName = item;
            } else {
                if (!this.dataList[index].APCode) {
                    this.dataList[index].APCode = item.APCode;
                    this.dataList[index].EntpTempGoodsId = item.EntpTempGoodsId;
                }
                this.dataList[index].GoodName = item.GoodName;
                this.dataList[index].VGoodName = item.GoodName;
                this.dataList[index].MainImage = item.MainImage;
                this.dataList[index].Price = item.CostPrice;
                this.dataList[index].Unit = item.Unit;
                this.dataList[index].AutoSerise = item.AutoSerise;
                this.dataList[index].AutoSeriseItem = item.AutoSerise;
                this.dataList[index].State = 0;

                this.dataList[index].Inventory = item.Inventory;
                this.dataList[index].StorageInventory = item.StorageInventory;
                this.dataList[index].OrderWaitOutQuantity = item.OrderWaitOutQuantity;
                this.dataList[index].POrderWaitInQuantity = item.POrderWaitInQuantity;
                this.dataList[index].Origin = item.Origin;
                this.dataList[index].Size = item.Size;

                // this.$util
                //     .getGoodsDataAfterSelItem(this.dataList[index].EntpTempGoodsId, this.submitData.WarehouseId, this.submitData.EntpCusId, '2', this.isIntentShow)
                //     .then(data => {
                //         if (data) {
                //             this.dataList[index].OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                //             this.dataList[index].POrderWaitInQuantity = data.POrderWaitInQuantity;
                //             this.dataList[index].StorageInventory = data.StorageInventory;
                //             if (data.LatestPurPrice > 0) this.dataList[index].Price = data.LatestPurPrice;
                //             if (this.isIntentShow) this.dataList[index].IntenCount = data.IntenCount;
                //         }
                //     });
            }
            this.priceChange();
        },
        // 编码改变
        codeChange(value, index) {
            let isNew = true;
            this.editIndex = index;
            let _list = this.codeList;
            if (!value) {
                this.dataList[index].IsNew = false;
            }
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].APCode == value) {
                    this.dataList[index].APCode = _list[i].APCode;
                    this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
                    this.dataList[index].GoodName = _list[i].GoodName;
                    this.dataList[index].GoodNameItem = _list[i].GoodName;
                    this.dataList[index].MainImage = _list[i].MainImage;
                    this.dataList[index].Price = _list[i].CostPrice;
                    this.dataList[index].Unit = _list[i].Unit;
                    this.dataList[index].AutoSerise = _list[i].AutoSerise;
                    this.dataList[index].AutoSeriseItem = _list[i].AutoSerise;
                    this.dataList[index].IsNew = false;
                    this.dataList[index].State = 0;
                    this.dataList[index].OrderWaitOutQuantity = _list[i].OrderWaitOutQuantity;
                    this.dataList[index].POrderWaitInQuantity = _list[i].POrderWaitInQuantity;
                    this.dataList[index].Inventory = _list[i].Inventory;
                    this.dataList[index].StorageInventory = _list[i].StorageInventory;
                    this.dataList[index].Origin = _list[i].Origin;
                    this.dataList[index].Size = _list[i].Size;
                    isNew = false;

                    // this.$util
                    //     .getGoodsDataAfterSelItem(this.dataList[index].EntpTempGoodsId, this.submitData.WarehouseId, this.submitData.EntpCusId, '2', this.isIntentShow)
                    //     .then(data => {
                    //         if (data) {
                    //             this.dataList[index].OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                    //             this.dataList[index].POrderWaitInQuantity = data.POrderWaitInQuantity;
                    //             this.dataList[index].StorageInventory = data.StorageInventory;
                    //             if (data.LatestPurPrice > 0) this.dataList[index].Price = data.LatestPurPrice;
                    //             if (this.isIntentShow) this.dataList[index].IntenCount = data.IntenCount;
                    //         }
                    //     });
                    break;
                }
            }
            if (isNew && value) {
                let that = this;
                this.$util.elConfirm({
                    content: '要创建一个新配件吗？',
                    noMsg: true,
                    confirm() {
                        that.dataList[index].EntpTempGoodsId = '';
                        that.dataList[index].Inventory = 0;
                        that.dataList[index].StorageInventory = 0;
                        that.dataList[index].Price = 0;
                        that.dataList[index].IsNew = true;
                        that.dataList[index].State = 0;
                        that.dataList[index].Origin = '';
                        that.dataList[index].Size = '';
                        that.$refs.infiniteTable.setActiveRow(that.dataList[index]);
                        that.$util
                            .axiosGet({
                                url: '/api/EntpGoods/GetPart',
                                data: {
                                    APCode: value
                                },
                                hideLoading: true
                            })
                            .then(res => {
                                if (res.data) {
                                    let data = res.data;
                                    that.dataList[index].APCode = data.APCode;
                                    that.dataList[index].AutoSerise = data.AutoSerise;
                                    that.dataList[index].AutoSeriseItem = data.AutoSerise;
                                    that.dataList[index].GoodName = data.GoodName;
                                    that.dataList[index].GoodNameItem = data.GoodName;
                                    that.dataList[index].Unit = data.Unit;
                                } else {
                                    that.addAPParams = {
                                        APCode: that.dataList[index].APCode,
                                        index: index
                                    };
                                    that.addAPVisible = true;
                                    if (that.$refs[`sapcode`]) {
                                        that.$refs[`sapcode`].blur();
                                    }
                                }
                            });
                    }
                });
            }
            this.priceChange();
        },
        //车型改变  AutoSeriseItem值仅仅用于选中值为对象的效果，实际上保存的数据还是AutoSerise
        seriseChange(item, index) {
            this.editIndex = index;
            if (!item) {
                this.dataList[index].AutoSerise = '';
            } else if (typeof item == 'string') {
                this.dataList[index].AutoSerise = item;
            } else {
                this.dataList[index].APCode = item.APCode;
                this.dataList[index].EntpTempGoodsId = item.EntpTempGoodsId;
                this.dataList[index].GoodName = item.GoodName;
                this.dataList[index].GoodNameItem = item.GoodName;
                this.dataList[index].VGoodName = item.GoodName;
                this.dataList[index].MainImage = item.MainImage;
                this.dataList[index].Price = item.CostPrice;
                this.dataList[index].Unit = item.Unit;
                this.dataList[index].AutoSerise = item.AutoSerise;
                this.dataList[index].State = 0;

                this.dataList[index].Inventory = item.Inventory;
                this.dataList[index].StorageInventory = item.StorageInventory;
                this.dataList[index].OrderWaitOutQuantity = item.OrderWaitOutQuantity;
                this.dataList[index].POrderWaitInQuantity = item.POrderWaitInQuantity;
                this.dataList[index].Origin = item.Origin;
                this.dataList[index].Size = item.Size;
                // this.$util
                //     .getGoodsDataAfterSelItem(this.dataList[index].EntpTempGoodsId, this.submitData.WarehouseId, this.submitData.EntpCusId, '2', this.isIntentShow)
                //     .then(data => {
                //         if (data) {
                //             this.dataList[index].OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                //             this.dataList[index].POrderWaitInQuantity = data.POrderWaitInQuantity;
                //             this.dataList[index].StorageInventory = data.StorageInventory;
                //             if (data.LatestPurPrice > 0) this.dataList[index].Price = data.LatestPurPrice;
                //             if (this.isIntentShow) this.dataList[index].IntenCount = data.IntenCount;
                //         }
                //     });
                this.priceChange();
            }
        },
        // 供应商改变
        customerChange(value) {
            let that = this;
            if (!value) {
                that.submitData.EntpCusName = '';
            } else {
                let currCust = that.customerList.find(e => e.EntpCusId == value);
                if (currCust) {
                    that.submitData.EntpCusName = currCust.EntpCusName;
                }
            }
            this.getDefaultData();
        },
        //单位下拉框显示时触发event
        unitVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.unitList.length == 0) that.getConfigData();
            }
        },
        //当供应商下拉框出现时触发
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.customerList.length <= 1) that.searchCustomer('');
            }
        },
        //当汽配件编码下拉框出现时触发
        apCodeVisibleChange(event) {
            let that = this;
            if (event && that.codeList.length == 0 && that.isPreloadApCodeList) {
                that.searchCode('');
            }
        },
        //当汽配件名称下拉框出现时触发
        apNameVisibleChange(event) {
            let that = this;
            if (event && that.nameList.length == 0 && that.isPreloadApCodeList) {
                that.searchName('');
            }
        },
        //当车系下拉框出现时触发
        autoSeriseVisibleChange(event, item) {
            let that = this;
            if (event && that.seriesList.length == 0 && that.isPreloadApCodeList) {
                that.searchAutoSerie('', item);
            }
        },
        addressVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.addressList.length <= 1) that.getAddressList();
            }
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length <= 1) that.getWarehouse();
            }
        },
        warehouseChange(val) {
            let that = this;
            if (!val) {
                that.submitData.WarehouseName = '';
                that.dataList.forEach((e, i) => {
                    e.StorageInventory = 0;
                });
            } else {
                for (let i = 0; i < that.warehouseList.length; i++) {
                    if (val == that.warehouseList[i].WarehouseId) {
                        that.submitData.WarehouseAddr = that.warehouseList[i].Address;
                        that.submitData.WarehouseName = that.warehouseList[i].WarehouseName;

                        if (that.warehouseList[i].Type == 1) this.canNotEditAddr = true;
                        else this.canNotEditAddr = false;

                        break;
                    }
                }

                // // 查询在这个仓库下的商品库存
                // if (that.dataList) {
                //     let ids = [];
                //     that.dataList.forEach((e, i) => {
                //         if (e.EntpTempGoodsId) ids.push(e.EntpTempGoodsId);
                //     });
                //     if (ids.length > 0) {
                //         that.$util
                //             .axiosPost({
                //                 url: '/api/EntpSaleOrder/GetGoodsStoragesInventorys',
                //                 data: {
                //                     sId: val,
                //                     ids: ids
                //                 }
                //             })
                //             .then(res => {
                //                 let data = res.data;
                //                 that.dataList.forEach((e, i) => {
                //                     let getStorage = data.find(d => d.GoodsId == e.EntpTempGoodsId);
                //                     if (getStorage) {
                //                         e.StorageInventory = getStorage.Count;
                //                         e.OrderWaitOutQuantity = getStorage.OrderWaitOutQuantity;
                //                         e.POrderWaitInQuantity = getStorage.POrderWaitInQuantity;
                //                     } else {
                //                         e.StorageInventory = 0;
                //                         e.OrderWaitOutQuantity = 0;
                //                         e.POrderWaitInQuantity = 0;
                //                     }
                //                 });
                //             })
                //             .catch(() => {});
                //     }
                // }
            }
        },
        // 历史销售
        showHistories(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.historyVisible = true;
            }
        },
        closeHistoryDialog() {
            this.historyVisible = false;
        },
        //快速添加仓库地址
        addAddress() {
            this.addressDialogVisible = true;
        },
        clearAddressDialog() {
            this.$refs.addAddress.resetForm();
            this.addressDialogVisible = false;
            this.formData = {};
            this.getAddressList();
        },
        showSaleStat(row) {
            if (row) {
                this.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.APId = row.EntpTempGoodsId;
                this.eyeHistoryVisible = true;
            }
        },
        analysis(row) {
            if (row) {
                this.APId = row.EntpTempGoodsId;
                this.goodsAnalysisVisible = true;
            }
        },
        // 设置展示合计数据行
        setSummaries() {
            if (!this.isOriginShow && !this.isSizeShow) {
                return [['', '', '', '总数量', this.allNum, '', '合计', this.allMoney.toFixed(3), '', '']];
            } else if (this.isOriginShow && this.isSizeShow) {
                return [['', '', '', '', '', '总数量', this.allNum, '', '合计', this.allMoney.toFixed(3), '', '']];
            } else {
                return [['', '', '', '', '总数量', this.allNum, '', '合计', this.allMoney.toFixed(3), '', '']];
            }
        },
        // 设置展示行样式
        setRowStyle(param) {
            const { row, index } = param;
            let rowArr = this.dataList.filter(f => f.APCode === row.APCode);
            if (rowArr.length > 1) {
                return `background-color: #FFE8E8`;
            }
        },
        showIntentSearch() {
            if (this.submitData.EntpCusId) {
                this.searchIntentVisible = true;
            } else {
                this.$util.warningMsg('请先选择供应商，再进行搜索在订商品');
            }
        },
        //手动清除单元格激活状态
        clearActived(e) {
            if (e.target.className == 'elx-table--body-wrapper body--wrapper') {
                this.$refs.infiniteTable.clearActived();
            }
            e.stopPropagation();
            e.preventDefault();
        },
        keyEvent(ev, code, row, index) {
            let that = this;
            if (ev.key == 'Enter') {
                if (code == 'Count' || code == 'Price') {
                    that.addItem(true);
                } else {
                    let inputAll = document.querySelectorAll('.purcounts-input-cell .el-input__inner');
                    inputAll[0].focus();
                }
            } else if (ev.key == 'ArrowLeft') {
                if (code == 'Count') {
                    if (that.$refs[`originRef`]) that.$refs[`originRef`].focus();
                    else that.$refs[`partsNameSelect`].focus();
                } else if (code == 'Price') {
                    let inputAll = document.querySelectorAll('.purcounts-input-cell .el-input__inner');
                    inputAll[0].focus();
                } else if (code == 'GoodName') {
                    that.$refs[`partsNameSelect`].blur();
                    let inputAll = document.querySelectorAll('.elx-cell .el-select .el-input__inner');
                    inputAll[0].focus();
                } else if (code == 'AutoSerise') {
                    that.$refs[`autoSeriseSelect`].blur();
                    let inputAll = document.querySelectorAll('.elx-cell .el-select .el-input__inner');
                    inputAll[1].focus();
                } else if (code == 'Origin') {
                    that.$refs[`autoSeriseSelect`].focus();
                }
            } else if (ev.key == 'ArrowRight') {
                if (code == 'Count') {
                    let inputAll = document.querySelectorAll('.sales-input-cell .el-input__inner');
                    inputAll[0].focus();
                } else if (code == 'APCode') {
                    that.$refs[`sapcode`].blur();
                    let inputAll = document.querySelectorAll('.elx-cell .el-select .el-input__inner');
                    inputAll[1].focus();
                } else if (code == 'GoodName') {
                    that.$refs[`partsNameSelect`].blur();
                    let inputAll = document.querySelectorAll('.elx-cell .el-select .el-input__inner');
                    inputAll[2].focus();
                } else if (code == 'AutoSerise') {
                    if (that.$refs[`originRef`]) that.$refs[`originRef`].focus();
                    else that.$refs[`countRef`].focus();
                } else if (code == 'Origin') {
                    that.$refs[`countRef`].focus();
                }
            }
        },
        orgVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.orgList.length <= 1)
                    that.$util.getParentOrgs().then(data => {
                        that.orgList = data;
                    });
            }
        },
        orgChange(val) {
            let that = this;
            if (val) {
                for (let i = 0; i < that.orgList.length; i++) {
                    if (val == that.orgList[i].Id) {
                        that.submitData.OrgName = that.orgList[i].Name;
                        break;
                    }
                }
            } else {
                that.submitData.OrgName = '';
            }
        }
    }
};
</script>
<style lang="less" scoped>
.el-form-item {
    margin-bottom: 0 !important;
}
.payment-tip {
    position: absolute;
    left: 0;
    bottom: -18px;
    line-height: 1;
    font-size: 12px;
    color: @font4Color;
}
.search-ctn {
    border: 1px solid @border3Color;
    padding-top: 10px;
    margin-bottom: 10px;
}
.inventory-title {
    line-height: 1.2;
    flex-direction: column;
    > div:nth-child(1) {
        width: 100%;
        border-bottom: 1px solid @border3Color;
    }
    > div:nth-child(2) {
        width: 100%;
        display: flex;
        > div {
            width: 33.33%;
        }
    }
}
.form-section {
    display: flex;
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.edit-ctn {
    .div-table-cell {
        padding: 0 5px;
    }
}
.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }

    .project-iven {
        width: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
.btn-ctn {
    margin-right: 110px;
    padding: 30px 0;
    text-align: right;
    padding-bottom: 180px;
}
.add-btn {
    position: absolute;
    right: 2%;
    bottom: 0;
}
.less-btn {
    position: absolute;
    right: -40px;
    top: 2px;
    z-index: 2;
}
.table-main {
    position: relative;
}
.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}
.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.table-item {
    height: 50px;
    position: relative;
}
.div-table-row {
    overflow: inherit;
    margin: -1px -1px -1px 0px;
}
.div-table-cell-code {
    position: relative;
    .row-delete {
        position: absolute;
        padding: 1px 6px;
        top: 0;
        right: 0;
        color: #fff;
        background: #ffcc66;
        border-radius: 12.5px;
    }
}

.addresscls {
    display: flex;
    flex-direction: row;
}
.addicon {
    height: 30px;
    margin-left: 10px;
    margin-top: 5px;
}
.head-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .color-red {
        margin-right: 4px;
    }
    .sort-view {
        display: flex;
        flex-direction: column;
        i {
            line-height: 8px;
            cursor: pointer;
        }
        .active {
            color: #409eff;
        }
    }
}
.saveProgress {
    position: absolute;
    top: 38%;
    left: 45%;
    z-index: 99999;
}
.el-icon-picture {
    color: rgb(240, 155, 27);
    font-size: 18px;
    vertical-align: top;
    margin-top: 3px;
    cursor: pointer;
    margin-right: 3px;
}
.el-icon-info {
    color: #87a7d6;
    font-size: 18px;
    vertical-align: top;
    cursor: pointer;
    margin-top: 2px;
    margin-right: 3px;
}
</style>

<style lang="less">
.order-infoes {
    border: 1px solid @border3Color;
    padding-top: 10px;
    margin-bottom: 10px;

    .grid-content {
        border-radius: 4px;
        min-height: 32px;
    }
    .el-form-item {
        margin-bottom: 0px;
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__label {
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__content {
        line-height: 32px !important;
        height: 32px;
        top: -1px;
    }
}
#search-dialog {
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .el-dialog__body {
        overflow: auto;
    }
}
#search-dialog::-webkit-scrollbar {
    display: none;
}
.el-row {
    margin-bottom: 10px;
    &:last-child {
        margin-bottom: 10px;
    }
}
.el-col {
    border-radius: 4px;
}
.bg-purple-dark {
    background: #99a9bf;
}
.bg-purple {
    background: #d3dce6;
}
.bg-purple-light {
    background: #e5e9f2;
}
.grid-content {
    border-radius: 4px;
    min-height: 36px;
}
.check-code-class {
    .el-input__inner {
        border: 1px solid #f56c6c;
    }
}
.trans-to-supplier-order-v2 {
    #search-dialog {
        margin-right: 35px;
    }
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }
        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }
                .div-padding-12 {
                    padding: 2px 8px 0;
                }
                .div-margin-op {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }
                .operate {
                    padding: 0 12px;
                }
                .text-btn {
                    button {
                        padding-left: 0;
                        padding-right: 0;
                    }
                }
                td {
                    height: 26px;
                }
            }
            .elx-cell {
                padding: 0;
                height: 32px;
            }
            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }
        .elx-table--footer-wrapper {
            margin-top: 0 !important;
            .elx-footer--row {
                .elx-footer--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }
        .elx-table--body-wrapper {
            padding-bottom: 180px !important;
        }
    }
    .sales-input-cell {
        .el-input-number {
            width: 100%;
        }
        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }
        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }
    .purcounts-input-cell {
        .el-input-number {
            width: 100%;
        }
        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }
        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }
    .infinite-list-special-class {
        .elx-table {
            .elx-table--body-wrapper {
                padding-bottom: 0 !important;
            }
        }
    }
    .bottom-div {
        margin-top: 24px;
        text-align: right;
    }
    .special-border {
        height: 100%;
        border-radius: 3px;
        border: 1px solid #ffcc00;
    }
    .sales-apcode {
        .el-tag {
            height: 24px;
            line-height: 22px;
            margin-left: 8px;
        }
        .info-icon {
            vertical-align: top;
            margin-top: 2px;
            margin-right: 5px;
        }
    }
}

.mbox_ext {
    width: auto !important;
}
</style>
